import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Relationship",
  "use": "Relationship-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Relationship\"><path d=\"M4 2.5a2.5 2.5 0 0 1 2.414 3.152l3.812 3.557A3.982 3.982 0 0 1 12.5 8.5c1.295 0 2.446.615 3.177 1.57l1.826-.971L17.5 9a2.5 2.5 0 0 1 2.336-2.495L20 6.5a2.5 2.5 0 1 1-1.623 4.401l-1.918 1.02a4 4 0 0 1-5.738 4.162l-1.535 1.704A2.5 2.5 0 1 1 7.59 16.57l1.619-1.796A3.982 3.982 0 0 1 8.5 12.5c0-.639.15-1.243.416-1.778l-3.76-3.505A2.5 2.5 0 1 1 4 2.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol